// extracted by mini-css-extract-plugin
export default {"back":"DrapandDrop_back__nG0QD"};